if (!customElements.get('slideshow-banner')) {
  customElements.define('slideshow-banner', class homepageHero extends HTMLElement {
    constructor() {
      super();

      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
    }

    isMobile() {
      return window.innerWidth < 768;
    }

    isPortrait() {
      return window.innerHeight > window.innerWidth;
    }

    isLandscape() {
      return window.innerWidth > window.innerHeight;
    }

    getTallestSlideHeight() {
      let slides = this.querySelectorAll('.section__homepage-hero .page-width');
      let tallestSlide = slides[0].offsetHeight;
      slides.forEach(slide => {
        if (slide.offsetHeight > tallestSlide) {
          tallestSlide = slide.offsetHeight;
        }
      });
      return tallestSlide;
    }

    init() {
      let slidesHero = this.querySelectorAll('.section__homepage-hero');
      if (slidesHero.length > 0) {
        if (this.isMobile() && this.isPortrait()) {
          slidesHero.forEach(slide => {
            slide.style.minHeight = this.getTallestSlideHeight() + 'px';
          });
        } else {
          slidesHero.forEach(slide => {
            slide.removeAttribute('style');
          });
        }
      }
    }
  });
}